import React from 'react'
//import {Link} from 'gatsby'
//import rawEmojis from '../../static/emojis/emojis.js'
import * as techStyle from './componentStyles/tech-stack.module.scss'
const AboutMe = () => {
    return (
            <div className={techStyle.content}>
            <h3 style={{textDecoration:"underline", textDecorationStyle:"double", fontWeight:"bold" }}>Tech Stack</h3>

            <div style={{marginTop:-15, marginBottom:5}}>
                <span className={techStyle.tag}>C#</span>
                <span className={techStyle.tag}>JS ES6</span>
                <span className={techStyle.tag}>TypeScript</span>
            </div>
        
            <div style={{marginBottom:5, whiteSpace:'nowrap'}}>
                <span className={techStyle.tag}>ASP.NET Core</span>
                <span className={techStyle.tag}>NestJs</span>
                <span className={techStyle.tag}>React-Native</span>
                <span className={techStyle.tag}>ReactJs</span>
                
            </div>

            <div style={{marginBottom:5}}>
                <span className={techStyle.tag}>MSSQL</span>
                <span className={techStyle.tag}>PGSQL</span>
                <span className={techStyle.tag}>MongoDB</span>
                <span className={techStyle.tag}>GraphQL</span>
                <span className={techStyle.tag}>Redis</span>
                <span className={techStyle.tag}>ElasticSearch</span>
            </div>
            
            <div>
                <span className={techStyle.tag}>EF Core</span>
                <span className={techStyle.tag}>Rest API</span>
                <span className={techStyle.tag}>SignalR</span>
                <span className={techStyle.tag}>RabbitMQ</span>
                <span className={techStyle.tag}>Linux</span>
                <span className={techStyle.tag}>Git</span>
                <span className={techStyle.tag}>Jwt</span>
            </div>

            <div style={{marginTop: 8}}>
                <span className={techStyle.tag}>Microservices</span>
                <span className={techStyle.tag}>Web Application Development</span>
                <span className={techStyle.tag}>Mobile App Development</span>
            </div>
            
        </div>
    )
}

export default AboutMe
